import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import { showToast } from '@app/providers/ToastProvider';

import MFA_METHODS_ENUM from '@pages/Verification/MFASetupPage/enums/MFA_METHODS.enum';

export interface GetVerificationMFACodeData {
	type: MFA_METHODS_ENUM.SMS | MFA_METHODS_ENUM.EMAIL;
	device_id: string;
	login: string;
}

export type GetVerificationMFACodeResponse = void;

const getVerificationMFACode = configRequest<GetVerificationMFACodeResponse, GetVerificationMFACodeData>({
	requestPrefix: 'mfa/getVerificationMFACode',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.MFA.GET_VERIFICATION_MFA_CODE(),
		method: HTTP_METHODS_ENUM.PUT,
		data,
	}),
	onSuccess: () => showToast.success('Verification code has been sent.'),
});

export default getVerificationMFACode;
